module.exports = __webpack_public_path__ + "static/media/small_and_big_star.18c328cc.png";